import React from 'react';
import { formatCurrency } from '../../utils/invoiceUtils';

const BudgetKpiCards = ({ kpis, onClickOpen, onClickAccepted, onClickExpired }) => {
  if (!kpis) return null;
  const num = (v) => Number(v || 0);
  const winRate = kpis.win_rate;
  return (
    <div className="row g-2 mb-3">
      <div className="col-md-3">
        <div className="card shadow-sm h-100" role={onClickOpen ? 'button' : undefined} onClick={onClickOpen}>
          <div className="card-body">
            <div className="text-muted small">En curso {num(kpis.abiertos_count) > 0 && `(${num(kpis.abiertos_count)})`}</div>
            <div className="h4 mb-0 text-primary">{formatCurrency(kpis.abiertos_total)}</div>
            <div className="text-muted mt-1" style={{ fontSize: '0.72rem', lineHeight: 1.1 }}>Pendientes de decisión</div>
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="card shadow-sm h-100" role={onClickAccepted ? 'button' : undefined} onClick={onClickAccepted}>
          <div className="card-body">
            <div className="text-muted small">Aceptado (mes)</div>
            <div className="h4 mb-0 text-success">{formatCurrency(kpis.aceptado_mes)}</div>
            <div className="text-muted mt-1" style={{ fontSize: '0.72rem', lineHeight: 1.1 }}>
              Total aceptado: {formatCurrency(kpis.aceptado_total)}
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="card shadow-sm h-100">
          <div className="card-body">
            <div className="text-muted small">Tasa de conversión</div>
            <div className="h4 mb-0">{winRate == null ? '—' : `${winRate}%`}</div>
            <div className="text-muted mt-1" style={{ fontSize: '0.72rem', lineHeight: 1.1 }}>
              {num(kpis.aceptado_count)} aceptados · {num(kpis.rechazado_count)} rechazados
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-3">
        <div className="card shadow-sm h-100" role={onClickExpired ? 'button' : undefined} onClick={onClickExpired}>
          <div className="card-body">
            <div className="text-muted small">Caducados {num(kpis.caducado_count) > 0 && `(${num(kpis.caducado_count)})`}</div>
            <div className="h4 mb-0 text-danger">{formatCurrency(kpis.caducado_total)}</div>
            <div className="text-muted mt-1" style={{ fontSize: '0.72rem', lineHeight: 1.1 }}>Fuera de validez</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BudgetKpiCards;
